export default "/fonts/vendor/tinymce/skins/lightgray/tinymce-small.eot?dc0cabeec3bedef24494062c9744369c";